/**
 * Design portfolio entries. Drop images into apps/web/public/images/design/
 * and reference them as '/images/design/<file>'. Newest first.
 */
const DESIGN_PROJECTS = [
    {
        slug: 'sample-brand-system',
        title: 'Sample Brand System',
        category: 'Branding',
        year: 2025,
        description: 'Placeholder entry — replace with a real project. Logo suite, type system, and collateral for a fictional studio.',
        image: '',
        tags: ['Identity', 'Typography', 'Print'],
        href: ''
    },
    {
        slug: 'sample-campaign',
        title: 'Sample Campaign',
        category: 'Motion / Social',
        year: 2024,
        description: 'Placeholder entry — a multi-channel campaign with animated social cut-downs and key art.',
        image: '',
        tags: ['Art Direction', 'Motion', 'Social'],
        href: ''
    }
];

export default DESIGN_PROJECTS;
